import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatio169Dropdown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 15,
	viewBox: "0 0 18 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.333 0.355469C16.8057 0.355469 17.9999 1.60897 18 3.15527V11.5557C17.9999 13.102 16.8057 14.3555 15.333 14.3555H2.66699C1.1943 14.3555 0.000101011 13.102 0 11.5557V3.15527C0.000100024 1.60897 1.19429 0.355469 2.66699 0.355469H15.333ZM2.66699 1.75586C1.93067 1.75586 1.33311 2.38216 1.33301 3.15527V11.5557C1.33311 12.3288 1.93067 12.9551 2.66699 12.9551H15.333C16.0693 12.9551 16.6669 12.3288 16.667 11.5557V3.15527C16.6669 2.38216 16.0693 1.75586 15.333 1.75586H2.66699ZM2.66699 8.05664C3.03497 8.05683 3.33291 8.37044 3.33301 8.75684C3.33301 9.91652 4.22859 10.8572 5.33301 10.8574H6.66699C7.03491 10.8576 7.33281 11.1703 7.33301 11.5566C7.33301 11.9431 7.03503 12.2567 6.66699 12.2568H2.66699C2.2988 12.2568 2 11.9432 2 11.5566V8.75684C2.0001 8.37033 2.29886 8.05664 2.66699 8.05664ZM15.333 2.45703C15.7012 2.45703 16 2.77063 16 3.15723V5.60742C15.9998 5.99384 15.7011 6.30664 15.333 6.30664C14.9651 6.30646 14.6672 5.99373 14.667 5.60742C14.667 4.64092 13.9205 3.85742 13 3.85742H11C10.6319 3.85742 10.3331 3.54374 10.333 3.15723C10.333 2.77063 10.6318 2.45703 11 2.45703H15.333Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatio169Dropdown);
export default ForwardRef;
